import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  wallet: null,

  isOpenAvailable: null,
  isLoginAvailable: null,

  links: null,

  createWalletStatus: null,
  createWalletLogin: null,
  createWalletPassword: null,

  loginUrlInvestor: null,
  loginUrlManager: null,

  accounts: null,
};

export const pammSlice = createSlice({
  name: 'pamm',
  initialState,
  reducers: {
    setPammWallet: (state, action) => {
      state.wallet = action.payload;
    },

    setPammOpenAvailability: (state, action) => {
      state.isOpenAvailable = action.payload;
    },
    setPammLoginAvailability: (state, action) => {
      state.isLoginAvailable = action.payload;
    },

    setPammLinks: (state, action) => {
      state.links = action.payload;
    },

    setCreatePammWalletStatus: (state, action) => {
      state.createWalletStatus = action.payload;
    },
    setCreatePammWalletLogin: (state, action) => {
      state.createWalletLogin = action.payload;
    },
    setCreatePammWalletPassword: (state, action) => {
      state.createWalletPassword = action.payload;
    },

    setPammLoginUrlInvestor: (state, action) => {
      state.loginUrlInvestor = action.payload;
    },
    setPammLoginUrlManager: (state, action) => {
      state.loginUrlManager = action.payload;
    },

    setPammAccounts: (state, action) => {
      state.accounts = action.payload;
    },

    resetPamm: () => initialState,
  },
});

export const {
  setPammWallet,

  setPammOpenAvailability,
  setPammLoginAvailability,

  setPammLinks,

  setCreatePammWalletStatus,
  setCreatePammWalletLogin,
  setCreatePammWalletPassword,

  setPammLoginUrlInvestor,
  setPammLoginUrlManager,

  setPammAccounts,

  resetPamm,
} = pammSlice.actions;

export default pammSlice.reducer;
